if (!customElements.get("recipient-form")) {
  customElements.define(
    "recipient-form",
    class RecipientForm extends HTMLElement {
      constructor() {
        super();

        this.recipientFieldsLiveRegion = this.querySelector(
          `#Recipient-Fields-Live-Region-${this.dataset.section}`,
        );

        this.checkboxInput = this.querySelector(
          `#Recipient-Checkbox-${this.dataset.section}`,
        );
        if (this.checkboxInput) {
          this.checkboxInput.disabled = false;
          this.checkboxInput.addEventListener(
            "change",
            this.onChange.bind(this),
          );
        }

        this.emailInput = this.querySelector(
          `#Recipient-email-${this.dataset.section}`,
        );
        this.nameInput = this.querySelector(
          `#Recipient-name-${this.dataset.section}`,
        );
        this.messageInput = this.querySelector(
          `#Recipient-message-${this.dataset.section}`,
        );
        this.send_onInput = this.querySelector(
          `#Recipient-send_on-${this.dataset.section}`,
        );

        this.offsetProperty = document.getElementById(
          `Recipient-Timezone-Offset-${this.dataset.section}`,
        );
        if (this.offsetProperty)
          this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.hiddenControlField = document.getElementById(
          `Recipient-Control-${this.dataset.section}`,
        );
        if (this.hiddenControlField) this.hiddenControlField.disabled = true;

        this.errorMessageWrapper = this.querySelector(
          ".recipient-form__errors",
        );
        this.errorMessageList = this.errorMessageWrapper?.querySelector(
          ".recipient-form__error-list",
        );

        this.currentProductVariantId = this.dataset.productVariantId;
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        const cartUpdateEvent =
          (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) ||
          "cart-update";
        const cartErrorEvent =
          (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartError) ||
          "cart-error";

        this._onCartUpdate = (event) => {
          const detail = event.detail || {};
          if (
            detail.source === "product-form" &&
            detail.productVariantId?.toString() ===
              this.currentProductVariantId
          ) {
            this.resetRecipientForm();
          }
        };

        this._onCartError = (event) => {
          const detail = event.detail || {};
          if (
            detail.source === "product-form" &&
            detail.productVariantId?.toString() ===
              this.currentProductVariantId
          ) {
            this.displayErrorMessage(detail.errors);
          }
        };

        this._onVariantChange = (event) => {
          const detail = event.detail || {};
          if (detail.sectionId === this.dataset.section && detail.variant) {
            this.currentProductVariantId = detail.variant.id.toString();
          }
        };

        document.addEventListener(cartUpdateEvent, this._onCartUpdate);
        document.addEventListener(cartErrorEvent, this._onCartError);
        document.addEventListener("variant:change", this._onVariantChange);
      }

      disconnectedCallback() {
        const cartUpdateEvent =
          (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) ||
          "cart-update";
        const cartErrorEvent =
          (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartError) ||
          "cart-error";

        if (this._onCartUpdate)
          document.removeEventListener(cartUpdateEvent, this._onCartUpdate);
        if (this._onCartError)
          document.removeEventListener(cartErrorEvent, this._onCartError);
        if (this._onVariantChange)
          document.removeEventListener(
            "variant:change",
            this._onVariantChange,
          );
      }

      onChange() {
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          if (this.recipientFieldsLiveRegion) {
            this.recipientFieldsLiveRegion.innerText =
              this.getAttribute("data-expanded-text") ||
              "Gift card recipient form expanded";
          }
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          if (this.recipientFieldsLiveRegion) {
            this.recipientFieldsLiveRegion.innerText =
              this.getAttribute("data-collapsed-text") ||
              "Gift card recipient form collapsed";
          }
        }
      }

      inputFields() {
        return [
          this.emailInput,
          this.nameInput,
          this.messageInput,
          this.send_onInput,
        ].filter(Boolean);
      }

      disableFields() {
        return [...this.inputFields(), this.offsetProperty].filter(Boolean);
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ""));
      }

      enableInputFields() {
        this.disableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableFields().forEach((field) => (field.disabled = true));
      }

      displayErrorMessage(errors) {
        this.clearErrorMessage();

        if (!this.errorMessageWrapper) return;

        this.errorMessageWrapper.hidden = false;
        this.errorMessageWrapper.focus();

        if (typeof errors === "object") {
          Object.entries(errors).forEach(([key, value]) => {
            const errorMessageId = `Recipient-Form-${key}-${this.dataset.section}-Error`;
            const message = Array.isArray(value) ? value.join(", ") : value;

            if (this.errorMessageList) {
              const li = document.createElement("li");
              li.id = errorMessageId;
              li.textContent = message;
              this.errorMessageList.appendChild(li);
            }

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute("aria-invalid", "true");
            inputElement.setAttribute("aria-describedby", errorMessageId);
            inputElement.closest(".line-field")?.classList.add("field-error");
          });
        }
      }

      clearErrorMessage() {
        if (this.errorMessageWrapper) this.errorMessageWrapper.hidden = true;
        if (this.errorMessageList) this.errorMessageList.innerHTML = "";

        this.inputFields().forEach((inputElement) => {
          inputElement.removeAttribute("aria-invalid");
          inputElement.removeAttribute("aria-describedby");
          inputElement.closest(".line-field")?.classList.remove("field-error");
        });
      }

      resetRecipientForm() {
        if (this.checkboxInput?.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          if (this.recipientFieldsLiveRegion) {
            this.recipientFieldsLiveRegion.innerText =
              this.getAttribute("data-collapsed-text") ||
              "Gift card recipient form collapsed";
          }
        }
      }
    },
  );
}
